import styled from 'styled-components';

export const OList = styled.ol`
  font-size: 16px;
  color: #767676;
  font-weight: normal;
  text-align: center;
  list-style-position: inside;
`;
